<template>
  <span>
    <b-row v-if="cards && cards.length" class="match-height">
      <b-col v-for="(card, index) in cards" :key="index" md="4" lg="3" class="mb-75">
        <b-card :title="getCardTitle(card)" :sub-title="card.engagement" class="text-center" border-variant="dark">
          <template #header>
            <span>
              {{ timeAgo(card.createdAt) }}
            </span>
            <!-- <b-badge :variant="card.isSubmitted ? 'success' : 'warning'" :class="card.isSubmitted ? 'badge-glow'
              : 'badge'">
              {{ card.isSubmitted ? 'Submitted' : 'Pending' }}
            </b-badge> -->
          </template>
          <b-card-text>
            {{ getBodyText(card) }}
          </b-card-text>
          <template v-if="getButtonText(card)" #footer>
            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-success"
              :to="{ name: 'survey-view', params: { id: card._id } }">
              {{ getButtonText(card) }}
            </b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
    <b-card v-else class="position-static">
      <blockquote class="blockquote mb-0">
        <p>No {{ surveyTypeToTitle(surveyType) }} Evaluation was requested.</p>
        <footer class="blockquote-footer">
          <span class="text-secondary h5">
            Please send a nomination request via the "Nominate" button on the right.
            <!-- <cite title="Source Title">Source Title</cite> -->
          </span>
        </footer>
      </blockquote>
    </b-card>
  </span>
</template>

<script>
import {
  BCard, BCardText, BRow, BCol, BImg, BLink, BButton, BProgress, BProgressBar, BBadge
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive';
import { timeAgo } from '../../utils';

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BLink,
    BImg,
    BButton,
    BProgress,
    BProgressBar,
    BBadge,
  },
  directives: {
    Ripple,
  },
  props: {
    surveyType: {
      type: String,
      required: true
    },
    cards: {
      type: Array,
      required: true
    },
  },
  methods: {
    surveyTypeToTitle(surveyType) {
      const userData = JSON.parse(localStorage.getItem('userData'))
      const category = userData.level.category;
      if (category && this.typeNames[category]) {
        return this.typeNames[category][surveyType];
      }
      return surveyType;
    },
    getCardTitle(card) {
      const category = card.reviewee.level.category;
      const prefix = this.typeNames[category] ? this.typeNames[category][this.surveyType] : this.surveyType;
      return `${prefix} Review from ${card.reviewer.fullName}`;
    },
    getButtonText(card) {
      // Not showing the button anymore
      return null
      // if (card.isSubmitted) {
      //   return "View Evaluation";
      // } else {
      //   return null;
      // }
    },
    getBodyText(card) {
      const text = `Performance review feedback from ${card.reviewer.fullName}.`
      return text
    },
    timeAgo,
  },
  beforeCreate() {
    this.$http.get('/questionnaires/types')
      .then(response => {
        this.typeNames = response.data;
      })
      .catch(error => console.log(error))
  },
  data() {
    return {
      typeNames: {}
    }
  }
}
</script>
